export const currencies = ['USD', 'GBP', 'EUR', 'CAD', 'AUD', 'CHF', 'MXN', 'NOK', 'SEK', 'DKK'];
export type SupportedCurrencies = (typeof currencies)[number];
